import getNeedsDashJs from "selectors/getNeedsDashJs";
import { createSelector } from "reselect";

const getHasTimeOffset = (_, ownProps) => !!ownProps.timeOffset;

export default createSelector(
  getHasTimeOffset,
  getNeedsDashJs,
  (needsDashJs, hasTimeOffset) => needsDashJs && hasTimeOffset,
);
